// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"24531e0c","177":"c7c88c79","192":"a373c696","664":"9f6ffff2","878":"38c287fe"}[chunkId] + ".chunk.js";
};